import { useEffect, useState } from "react";
// import "./assesment.css";
import { useParams, useNavigate } from "react-router-dom";
import {
  GetInterviewSheet,
  GetConclusionStatus,
  SubmitInterviewSheet,
  GetInterviewResume,
  GetPreviousInterviewSheet,
  IsAssessmentSheetFilled,
} from "../Services/InterviewService";
import NormalAlert from "../../../Alerts/NormalAlert";
import {
  User,
  Mail,
  Calendar,
  Phone,
  MapPin,
  IndianRupee,
  Briefcase,
  Clock,
  Move,
  DoorOpen,
  MessageSquare,
  Building2,
  Layers,
  Globe,
  Users,
  UserCheck,
  Lightbulb,
  Receipt,
  MessageCircle,
  FileText,
} from "lucide-react";
import InterviewDecisionModal from "../Modal/InterviewDecisionModal";
import ViewResumeModal from "../../../Employee/Jobs/SendCandidates/Modals/ViewResumeModal";
import PreviousFeedbackModal from "../Modal/PreviousFeedbackModal";
import { type } from "@testing-library/user-event/dist/type";

const InterviewerAssesmentSheet = () => {
  const { InterviewUID } = useParams();

  // const { candidateDetails } = data;
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [responses, setResponses] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [candidateDetails, setCandidateDetails] = useState(null);
  const [jobDetails, setjobDetails] = useState(null);
  const [interviewerDetails, setinterviewerDetails] = useState(null);
  const [alert, setAlert] = useState(null);
  const [errors, setErrors] = useState({});
  const [statusList, setStatusList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showCandidateDetails, setShowCandidateDetails] = useState(false);
  const [showPositionDetails, setShowPositionDetails] = useState(false);
  //   const [showResume, setShowResume] = useState(false);
  const [showInterviewerDetails, setShowInterviewerDetails] = useState(false);
  const [resumeUrl, setResumeUrl] = useState("");
  const [showResume, setShowResume] = useState(false);

  const [previousFeedback, setPreviousFeedback] = useState([]);
  const [showPrevModal, setShowPrevModal] = useState(false);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const checkAndFetch = async () => {
      try {
        const checkRes = await IsAssessmentSheetFilled(InterviewUID);

        if (checkRes.data.status === "Fail") {
          setAlert({
            type: "fail",
            message: checkRes.data.message,
          });

          setTimeout(() => {
            navigate("/");
          }, 1500);

          return;
        }

        const response = await GetInterviewSheet(InterviewUID);

        if (response) {
          setCandidateDetails(response.data.candidateDetails);
          setjobDetails(response.data.jobDetails);
          setinterviewerDetails(response.data.interviewerDetails);
          setQuestions(response.data.interviewQuestions);
        }
      } catch (error) {
        const safeMessage =
          error?.response?.data?.message ||
          "Something went wrong. Please try again.";

        setAlert({
          type: "fail",
          message: safeMessage,
        });
      }
    };

    const fetchInterviewConclusionStatus = async () => {
      try {
        const Response = await GetConclusionStatus(InterviewUID);
        setStatusList(Response.data.allStatus || []);
      } catch (err) {
        setAlert({
          type: "fail",
          message:
            err.response?.data?.message ||
            "Something went wrong. Please try again.",
        });
      }
    };

    checkAndFetch();
    fetchInterviewConclusionStatus();
  }, [InterviewUID, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};

    questions.forEach((q) => {
      const res = responses[q.id];

      //  Case 1 (Yes/No)
      if (q.questionType === 1) {
        if (!res || res.Rating === undefined) {
          newErrors[q.id] = "Please select Yes or No";
        } else if (res.Rating === "1" && (!res.Remark || !res.Remark.trim())) {
          newErrors[q.id] = "Remark is required";
        }
      }

      // Existing
      if (q.questionType === 2) {
        if (!res || !res.Rating) {
          newErrors[q.id] = "This question is required";
        }
      }

      if (q.questionType === 3 || q.questionType === 4) {
        if (!res || !res.Remark || !res.Remark.trim()) {
          newErrors[q.id] = "Remark is required";
        }
      }
    });
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setAlert({
        type: "fail",
        message: "Please answer all questions.",
      });
      return;
    }

    setShowModal(true);
  };

  const today = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const closeModal = () => {
    setShowModal(false);
  };

  const SkipFeedback = () => {
    setShowModal(true);
  };

  const handleSelect = async () => {
    const newErrors = {};
    if (!selectedStatus || selectedStatus === "") {
      newErrors.selectedStatus =
        "Please select an interview conclusion status.";
    }
    if (!remarks || !remarks.toString().trim()) {
      newErrors.remarks = "Please enter interview remarks.";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setAlert({
        type: "fail",
        message: newErrors.selectedStatus || newErrors.remarks,
      });

      if (newErrors.selectedStatus) {
        const sel = document.querySelector(".modal select");
        if (sel) sel.focus();
      } else if (newErrors.remarks) {
        document.getElementById("remarks")?.focus();
      }
      return;
    }

    setAlert(null);
    setErrors({});

    const responseArray = Object.entries(responses).map(([id, data]) => ({
      QuestionID: parseInt(id),
      ...data,
    }));
    try {
      const response = await SubmitInterviewSheet(
        InterviewUID,
        selectedStatus,
        remarks,
        responseArray,
      );
      if (response) {
        setAlert({
          type: "success",
          message: response.data.message || "Submited Successfully.",
        });
        setTimeout(() => {
          navigate("/");
        }, 1500);
      }
    } catch (error) {
      const safeMessage =
        error?.response?.data?.message ||
        "Something went wrong. Please try again.";

      setAlert({
        type: "fail",
        message: safeMessage,
      });
    }
    closeModal();
  };

  const handleChange = (id, value, type) => {
    setResponses((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [type]: value,
      },
    }));

    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[id];
      return newErrors;
    });

    setAlert(null);
  };
  const renderQuestion = (question, index) => {
    const { id, question: qText, description, questionType } = question;
    const response = responses[id] || {};

    switch (questionType) {
      case 1:
        return (
          <div className="mt-3">
            <div className="flex gap-8 items-center">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name={`yesno-${id}`}
                  value="1"
                  checked={response.Rating === "1"}
                  onChange={(e) => handleChange(id, e.target.value, "Rating")}
                  className="accent-blue-600 w-4 h-4"
                />
                <span className="text-gray-700">Yes</span>
              </label>

              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name={`yesno-${id}`}
                  value="0"
                  checked={response.Rating === "0"}
                  onChange={(e) => handleChange(id, e.target.value, "Rating")}
                  className="accent-blue-600 w-4 h-4"
                />
                <span className="text-gray-700">No</span>
              </label>
            </div>

            {response.Rating === "1" && (
              <div className="mt-4">
                <label className="text-sm text-gray-600 font-medium">
                  Remark
                </label>

                <textarea
                  className="w-full mt-1 border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Please provide details..."
                  value={response.Remark || ""}
                  onChange={(e) => handleChange(id, e.target.value, "Remark")}
                />
              </div>
            )}
          </div>
        );

      case 2:
        return (
          <div className="mt-4">
            {/* Rating Stars */}
            <div className="flex justify-center gap-2 mb-3">
              {["1", "2", "3", "4"].map((num) => (
                <span
                  key={num}
                  role="radio"
                  aria-checked={response.Rating === num}
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleChange(id, num, "Rating");
                  }}
                  onClick={() => handleChange(id, num, "Rating")}
                  className={`cursor-pointer text-2xl transition-transform
            ${
              response.Rating >= num
                ? "text-yellow-400 scale-110"
                : "text-gray-300"
            } hover:scale-125`}
                >
                  ★
                </span>
              ))}
            </div>

            {response.Rating && (
              <div>
                <label className="text-sm text-gray-600 font-medium">
                  Remark
                </label>

                <textarea
                  className="w-full mt-1 border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Remark on rating..."
                  value={response.Remark || ""}
                  onChange={(e) => handleChange(id, e.target.value, "Remark")}
                />
              </div>
            )}
          </div>
        );

      case 3:
      case 4:
        return (
          <div className="mt-4">
            <label className="text-sm text-gray-600 font-medium">Remark</label>

            <textarea
              className="w-full mt-1 border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Your remark"
              value={response.Remark || ""}
              onChange={(e) => handleChange(id, e.target.value, "Remark")}
            />
          </div>
        );

      default:
        return null;
    }
  };

  const handleResumeClick = async () => {
    try {
      if (!candidateDetails?.resumePath) {
        setAlert({
          type: "fail",
          message: "Resume not available.",
        });
        return;
      }

      const resumeFileName = candidateDetails.resumePath.split("/").pop();

      const response = await GetInterviewResume(resumeFileName, InterviewUID);

      // Create blob URL
      const pdfBlob = new Blob([response.data], {
        type: "application/pdf",
      });

      const pdfUrl = URL.createObjectURL(pdfBlob);

      setResumeUrl(pdfUrl);
      setShowResume(true);
    } catch (error) {
      setAlert({
        type: "fail",
        message: error?.response?.data?.message || "Unable to load resume.",
      });
    }
  };

  const Input = ({ label, value, Icon }) => (
    <div>
      <label className="flex items-center gap-2 font-semibold text-gray-700 mb-1">
        {Icon && <Icon size={18} className="text-blue-600" />}
        {label}
      </label>

      <input
        value={value || ""}
        readOnly
        className="w-full bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 font-medium text-gray-800"
      />
    </div>
  );

  useEffect(() => {
    const fetchPrevious = async () => {
      try {
        const res = await GetPreviousInterviewSheet(
          InterviewUID,
          candidateDetails?.submissionUID,
        );

        if (res.data.status === "Success" && res.data.feedbacks.length > 0) {
          setPreviousFeedback(res.data.feedbacks);
          setShowButton(true);
        } else {
          setShowButton(false);
        }
      } catch (err) {
        setShowButton(false);
      }
    };

    if (candidateDetails) {
      fetchPrevious();
    }
  }, [InterviewUID, candidateDetails]);

  return (
    <>
      {candidateDetails && (
        <div className="max-w-7xl mx-auto py-6 px-4">
          <div className="flex flex-col items-center">
            <div className="w-full">
              {/* Card */}
              <div className="bg-white rounded-xl shadow-[0_20px_40px_rgba(0,0,0,0.1)] backdrop-blur-md border-t-4 animate-[fadeInUp_.5s_ease-in-out]">
                {/* Header */}
                <div className="relative bg-gradient-to-r from-blue-700 to-cyan-400 text-white rounded-t-xl px-8 py-8 flex items-center">
                  {/* CENTER TITLE (ABSOLUTE = PERFECT CENTER) */}
                  <h2 className="absolute left-1/2 -translate-x-1/2 text-3xl font-bold">
                    Interview Assessment Form
                  </h2>

                  {/* RIGHT BUTTON */}
                  <div className="ml-auto">
                    {showButton && (
                      <button
                        onClick={() => setShowPrevModal(true)}
                        className="flex items-center gap-2 bg-white text-blue-700 px-4 py-2 rounded-lg font-medium shadow hover:bg-gray-100 transition"
                      >
                        <FileText size={18} />
                        View Previous Feedback
                      </button>
                    )}
                  </div>
                </div>

                {/* Sticky Info Row */}
                <div className="sticky top-0 z-40 bg-gradient-to-r from-blue-700 to-cyan-400 text-white shadow-md">
                  <div className="grid md:grid-cols-4 gap-6 text-center text-sm md:text-base px-8 py-4">
                    <div>
                      Candidate:
                      <span className="font-semibold ml-1">
                        {candidateDetails.name}
                      </span>
                    </div>

                    <div>
                      Job Title:
                      <span className="font-semibold ml-1">
                        {jobDetails.jobTitel}
                      </span>
                    </div>

                    <div>
                      Location:
                      <span className="font-semibold ml-1">
                        {jobDetails.location}
                      </span>
                    </div>

                    <div>
                      Date:
                      <span className="font-semibold ml-1">{today}</span>
                    </div>
                  </div>
                </div>

                <div className="p-6">
                  {/* Candidate Details */}
                  <div className="mb-6">
                    <h4
                      onClick={() =>
                        setShowCandidateDetails(!showCandidateDetails)
                      }
                      className="flex justify-between items-center cursor-pointer text-blue-600 font-bold text-lg px-6 py-4 rounded shadow-md bg-white"
                    >
                      <span className="flex items-center gap-2">
                        <User size={20} />
                        Candidate Details
                      </span>
                      <span>{showCandidateDetails ? "▲" : "▼"}</span>
                    </h4>

                    <div
                      className={`overflow-hidden transition-all duration-500 ${
                        showCandidateDetails
                          ? "max-h-[1500px] opacity-100"
                          : "max-h-0 opacity-0"
                      }`}
                    >
                      <div className="grid md:grid-cols-2 gap-6 mt-4 px-6">
                        <Input
                          label="Candidate Name"
                          value={candidateDetails.name}
                          Icon={User}
                        />

                        <Input
                          label="Email"
                          value={candidateDetails.email}
                          Icon={Mail}
                        />

                        <Input
                          label="Date of Birth"
                          value={candidateDetails.dateOfBirth}
                          Icon={Calendar}
                        />

                        <Input
                          label="Mobile Number"
                          value={candidateDetails.mobile}
                          Icon={Phone}
                        />

                        <Input
                          label="Current Location"
                          value={candidateDetails.currentLocation}
                          Icon={MapPin}
                        />

                        <Input
                          label="Expected CTC"
                          value={candidateDetails.expectedCTC}
                          Icon={IndianRupee}
                        />

                        <Input
                          label="Total Experience"
                          value={candidateDetails.totalExperience}
                          Icon={Briefcase}
                        />

                        <Input
                          label="Notice Period"
                          value={candidateDetails.noticePeriod}
                          Icon={Clock}
                        />

                        <Input
                          label="Ready to Relocate"
                          value={candidateDetails.readytoRelocate}
                          Icon={Move}
                        />

                        <Input
                          label="Reason of Leaving"
                          value={candidateDetails.reasonofLeaving}
                          Icon={DoorOpen}
                        />

                        <Input
                          label="Remarks"
                          value={candidateDetails.remarks}
                          Icon={MessageSquare}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Position Details */}
                  <div className="mb-6">
                    <h4
                      onClick={() =>
                        setShowPositionDetails(!showPositionDetails)
                      }
                      className="flex justify-between items-center cursor-pointer text-blue-600 font-bold text-lg px-6 py-4 rounded shadow-md bg-white"
                    >
                      <span className="flex items-center gap-2">
                        <Briefcase size={20} />
                        Position Details
                      </span>
                      <span>{showPositionDetails ? "▲" : "▼"}</span>
                    </h4>

                    <div
                      className={`overflow-hidden transition-all duration-500 ${
                        showPositionDetails
                          ? "max-h-[1500px] opacity-100"
                          : "max-h-0 opacity-0"
                      }`}
                    >
                      <div className="grid md:grid-cols-2 gap-6 mt-4 px-6">
                        <Input
                          label="Job Title"
                          value={jobDetails.jobTitel}
                          Icon={Briefcase}
                        />

                        <Input
                          label="Department"
                          value={jobDetails.department}
                          Icon={Building2}
                        />

                        <Input
                          label="Location"
                          value={jobDetails.location}
                          Icon={MapPin}
                        />

                        <Input
                          label="Zone"
                          value={jobDetails.zone}
                          Icon={Globe}
                        />

                        <Input
                          label="Function Name"
                          value={jobDetails.functionName}
                          Icon={Layers}
                        />

                        <Input
                          label="Gender Preference"
                          value={jobDetails.genderPreference}
                          Icon={Users}
                        />

                        <Input
                          label="Grade"
                          value={jobDetails.grade}
                          Icon={Layers}
                        />

                        <Input
                          label="Offered Salary"
                          value={jobDetails.offeredSalary}
                          Icon={IndianRupee}
                        />

                        <Input
                          label="Minimum Qualification"
                          value={jobDetails.genderPreference}
                          Icon={UserCheck}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Interviewer Details */}
                  <div className="mb-6">
                    <h4
                      onClick={() =>
                        setShowInterviewerDetails(!showInterviewerDetails)
                      }
                      className="flex justify-between items-center cursor-pointer text-blue-600 font-bold text-lg px-6 py-4 rounded shadow-md bg-white"
                    >
                      <span className="flex items-center gap-2">
                        <UserCheck size={20} />
                        Interviewer Details
                      </span>
                      <span>{showInterviewerDetails ? "▲" : "▼"}</span>
                    </h4>

                    <div
                      className={`overflow-hidden transition-all duration-500 ${
                        showInterviewerDetails
                          ? "max-h-[500px] opacity-100"
                          : "max-h-0 opacity-0"
                      }`}
                    >
                      <div className="grid md:grid-cols-2 gap-6 mt-4 px-6">
                        <Input
                          label="Employee Code"
                          value={interviewerDetails.employeeCode}
                          Icon={User}
                        />

                        <Input
                          label="Full Name"
                          value={interviewerDetails.fullName}
                          Icon={UserCheck}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Interview Questions */}

                  <div className="px-6 py-4 my-4 text-blue-600 font-bold text-xl rounded-md shadow-[-4px_2px_4px_rgba(0,0,0,0.1)] flex items-center gap-3">
                    <MessageCircle size={20} className="text-blue-600" />
                    Feedback
                  </div>

                  <div className="px-6">
                    {questions.length > 0 ? (
                      (() => {
                        const renderedSections = new Set();

                        const sectionHeaders = {
                          1: {
                            title: "Worked with Generali Central",
                            icon: Building2,
                          },
                          2: {
                            title: "Competencies",
                            icon: Lightbulb,
                          },
                          3: {
                            title: "Sales Commitment Sheet",
                            icon: Receipt,
                          },
                          4: {
                            title: "Role Dimension",
                            icon: Receipt,
                          },
                        };

                        return questions.map((question, index) => {
                          const { questionType } = question;

                          const shouldRenderHeader =
                            !renderedSections.has(questionType);

                          if (shouldRenderHeader)
                            renderedSections.add(questionType);

                          const Icon = sectionHeaders[questionType]?.icon;

                          return (
                            <>
                              <div key={question.id} className="mb-8">
                                {/* Section Header */}
                                {shouldRenderHeader &&
                                  sectionHeaders[questionType] && (
                                    <div className="flex items-center gap-2 text-blue-600 font-semibold text-lg mb-5">
                                      <span>-</span>

                                      {Icon && <Icon size={18} />}

                                      {sectionHeaders[questionType].title}
                                    </div>
                                  )}

                                {/* Question Card */}
                                <div className="border-2 border-gray-200 rounded-xl p-6 bg-gradient-to-br from-gray-50 to-gray-100 transition-all duration-300 hover:border-blue-500 hover:-translate-y-1 hover:shadow-md focus-within:border-blue-500">
                                  <div className="text-blue-600 font-semibold text-lg mb-2">
                                    {question.question}{" "}
                                    <span className="text-red-500">*</span>
                                  </div>

                                  <div className="text-gray-500 text-sm mb-4">
                                    {question.description}
                                  </div>

                                  {renderQuestion(question, index)}
                                </div>
                                {errors[question.id] && (
                                  <div className="text-red-500 text-sm mt-2 ml-2">
                                    {errors[question.id]}
                                  </div>
                                )}
                              </div>
                            </>
                          );
                        });
                      })()
                    ) : (
                      <p>Loading questions...</p>
                    )}
                  </div>

                  <div className="text-center mt-10">
                    <button
                      onClick={handleSubmit}
                      className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-12 py-3 rounded-full font-semibold transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_25px_rgba(13,110,253,0.3)]"
                    >
                      Submit Assessment
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Resume Icon */}
          {/* Resume Icon */}
          <div
            onClick={handleResumeClick}
            className="fixed right-6 top-1/2 -translate-y-1/2 bg-white rounded-full p-3 shadow-lg cursor-pointer transition hover:scale-110"
          >
            <FileText size={26} className="text-blue-600" />
          </div>

          {/* Resume Modal */}
          <ViewResumeModal
            show={showResume}
            onClose={() => setShowResume(false)}
            resumeUrl={resumeUrl}
          />

          <PreviousFeedbackModal
            show={showPrevModal}
            onClose={() => setShowPrevModal(false)}
            feedbacks={previousFeedback}
          />

          <InterviewDecisionModal
            show={showModal}
            onClose={closeModal}
            onFinish={handleSelect}
            statusList={statusList}
            selectedStatus={selectedStatus}
            setSelectedStatus={setSelectedStatus}
            remarks={remarks}
            setRemarks={setRemarks}
          />
        </div>
      )}

      {alert && (
        <NormalAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}
    </>
  );
};

export default InterviewerAssesmentSheet;
